import { render, staticRenderFns } from "./runWaterHisRecord.vue?vue&type=template&id=a9f8b312&scoped=true"
import script from "./runWaterHisRecord.vue?vue&type=script&lang=js"
export * from "./runWaterHisRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9f8b312",
  null
  
)

export default component.exports